import type { Phone } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  createContext,
  useContext,
} from "react"

export interface PhoneNumberModalContextValue {
  openPhoneNumberModal: (phone?: Phone) => void;
}

type ContextType = PhoneNumberModalContextValue | null
export const PhoneNumberModalContext = createContext<ContextType>(null)

export function usePhoneNumberModalContext() {
  const context = useContext(PhoneNumberModalContext)

  if (context === null) {
    throw new Error("PhoneNumberModal components must be wrapped in <PhoneNumberModalContext />")
  }

  return context
}

